module.exports = __webpack_public_path__ + "static/media/healthy-living-brown.fc5cad49.svg";